import { render, staticRenderFns } from "./ProgramSlotCard.vue?vue&type=template&id=1855a00a"
import script from "./ProgramSlotCard.vue?vue&type=script&lang=ts"
export * from "./ProgramSlotCard.vue?vue&type=script&lang=ts"
import style0 from "./ProgramSlotCard.vue?vue&type=style&index=0&id=1855a00a&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProgramLangBadges: require('/builds/project/wyffest/frontend/components/program/ProgramLangBadges.vue').default,AppIcon: require('/builds/project/wyffest/frontend/components/app/AppIcon.vue').default,ProgramSlotSpeaker: require('/builds/project/wyffest/frontend/components/program/ProgramSlotSpeaker.vue').default})
